import React, { useState } from 'react';

const faqs = [
    { q: 'Registration kaise karein?', a: 'Home page pe apni category choose karo — 10th, ITI ya Diploma. Phir form bharo, bilkul free hai!' },
    { q: 'Kya free hai registration?', a: 'Haan, 100% free! Koi payment nahi, koi hidden charge nahi.' },
    { q: 'Form kaise bharen?', a: 'Apni category select karo, form khulega. Apni personal aur education details bharo aur submit karo.' },
    { q: 'Job kab milegi?', a: 'Form submit karne ke 48 ghante ke andar hamara contractor aapse contact karega.' },
    { q: 'Kin districts mein job milti hai?', a: 'Pune, Mumbai, Gujarat, Nashik — Bihar ke bahar mostly. Kuch local jobs bhi available hain.' },
    { q: 'Resume kaise banayein?', a: 'Navbar mein AI Resume option pe click karo. Apni details likho, AI automatically resume banayega.' },
];

function ChatBot() {
    const [isOpen, setIsOpen] = useState(false);
    const [messages, setMessages] = useState([
        { from: 'bot', text: 'Namaste! 🙏 Main JobFreedom ka assistant hun. Aapki kaise help kar sakta hun?' }
    ]);
    const [input, setInput] = useState('');

    const handleSend = () => {
        if (!input.trim()) return;

        const userMsg = { from: 'user', text: input };
        setMessages(prev => [...prev, userMsg]);

        // Simple FAQ matching
        const matched = faqs.find(f =>
            input.toLowerCase().includes(f.q.toLowerCase().split(' ')[0]) ||
            f.q.toLowerCase().includes(input.toLowerCase().split(' ')[0])
        );

        const botReply = matched
            ? matched.a
            : 'Yeh sawaal main samajh nahi paya. Please support@jobfreedom.in pe email karo ya WhatsApp karo.';

        setTimeout(() => {
            setMessages(prev => [...prev, { from: 'bot', text: botReply }]);
        }, 600);

        setInput('');
    };

    const handleFaq = (faq) => {
        setMessages(prev => [
            ...prev,
            { from: 'user', text: faq.q },
            { from: 'bot', text: faq.a }
        ]);
    };

    return (
        <>
            {/* ── FLOATING BUTTON ── */}
            <button
                onClick={() => {
                    setIsOpen(!isOpen);
                    if (!isOpen) {
                        setMessages([
                            { from: 'bot', text: 'Namaste! 🙏 Main JobFreedom ka assistant hun. Aapki kaise help kar sakta hun?' }
                        ]);
                    }
                }}
                className="fixed bottom-6 right-6 z-50 bg-saffron-500 hover:bg-saffron-600 text-white w-14 h-14 rounded-full shadow-lg shadow-saffron-500/40 text-2xl transition flex items-center justify-center"
            >
                {isOpen ? '✕' : '💬'}
            </button>

            {/* ── CHAT WINDOW ── */}
            {isOpen && (
                <div className="fixed bottom-24 right-6 z-50 w-80 bg-dark-200 border border-gray-800 rounded-2xl shadow-2xl flex flex-col overflow-hidden">

                    {/* Header */}
                    <div className="bg-saffron-500 px-4 py-3 flex items-center gap-3">
                        <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center text-sm">🤖</div>
                        <div>
                            <p className="text-white font-semibold text-sm">JobFreedom Assistant</p>
                            <p className="text-white/70 text-xs">Online • Turant Reply</p>
                        </div>
                    </div>

                    {/* Messages */}
                    <div className="flex flex-col gap-3 p-4 h-64 overflow-y-auto">
                        {messages.map((msg, i) => (
                            <div key={i} className={`flex ${msg.from === 'user' ? 'justify-end' : 'justify-start'}`}>
                                <div className={`max-w-[85%] px-4 py-2 rounded-2xl text-sm leading-relaxed ${msg.from === 'user'
                                    ? 'bg-saffron-500 text-white rounded-br-none'
                                    : 'bg-dark-300 text-gray-300 rounded-bl-none'
                                    }`}>
                                    {msg.text}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* FAQ Shortcuts */}
                    <div className="px-4 pb-2 flex flex-wrap gap-2">
                        {faqs.slice(0, 3).map((faq, i) => (
                            <button
                                key={i}
                                onClick={() => handleFaq(faq)}
                                className="text-xs bg-dark-300 hover:bg-dark-100 text-gray-400 hover:text-saffron-500 border border-gray-700 px-3 py-1 rounded-full transition"
                            >
                                {faq.q}
                            </button>
                        ))}
                    </div>

                    {/* Input */}
                    <div className="p-4 border-t border-gray-800 flex gap-2">
                        <input
                            type="text"
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && handleSend()}
                            placeholder="Kuch poochho..."
                            className="flex-1 bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white text-sm rounded-xl px-3 py-2 outline-none transition placeholder-gray-600"
                        />
                        <button
                            onClick={handleSend}
                            className="bg-saffron-500 hover:bg-saffron-600 text-white px-4 py-2 rounded-xl text-sm transition"
                        >
                            →
                        </button>
                    </div>

                </div>
            )}
        </>
    );
}

export default ChatBot;